import React, { Component } from "react";
import { Row, Form, Col } from "react-bootstrap";
import debounce from "lodash-es/debounce";
import RequestsHistoryTable from "./components/requests_history_table.component";
import { Api } from "../utils/api";
import { Invoicexpress } from "../utils/invoicexpress";
import Grid from "@material-ui/core/Grid";
import TablePagination from "@material-ui/core/TablePagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import { observer } from "mobx-react";
import { RequestsHistoryFilterForm } from "./forms/requests-history-filter.form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button/Button";

const RequestsHistoryListing = observer(
  class RequestsHistoryListing extends Component {
    rowsPerPage = 5;

    state = {
      easypay_payments_history: null,
      invoices: [],
      receipts: [],
    };

    constructor() {
      super();
      this.api = new Api();
      this.iexpress = new Invoicexpress();
      this.search = debounce(this.searchInitial.bind(this), 250, {
        leading: true,
      });
      this.onChange = this.onChange.bind(this);
      this.handleChangePage = this.handleChangePage.bind(this);
      this.advancedChange = this.advancedChange.bind(this);
      this.toggleAdvancedFilter = this.toggleAdvancedFilter.bind(this);
      this.getInvoicexpressData = this.getInvoicexpressData.bind(this);
    }

    componentDidMount() {
      this.rowsPerPage =
        this.props && this.props.entity_id ? 10 : this.rowsPerPage;
      this.search();
    }

    /**
     * Search bar
     */

    searchInitial() {
      const { query, searchValues } = this.props.store;
      const params = {
        search: query,
        ...searchValues,
        entity_id: this.props.entity_id,
      };
      const { page } = this.props.store;
      this.api
        .get("/easypay_payments_history", {
          ...params,
          page: page + 1,
          rows: this.rowsPerPage,
        })
        .then(({ data: { easypay_payments_history, count } }) => {
          this.setState({ easypay_payments_history });
          this.props.store.setCount(count);
          this.getInvoicexpressData();
        });
    }

    handleChangePage(event, page) {
      this.props.store.setPage(page);
      this.search();
    }

    onChange(event) {
      this.props.store.setQuery(event.target.value);
      this.search();
    }

    toggleAdvancedFilter() {
      this.props.store.toggleAdvancedFilter();
      this.search();
    }

    advancedChange(query) {
      this.props.store.setSearchValues(query);
      this.search();
    }

    getInvoicexpressData() {
      let payments = this.state.easypay_payments_history;
      payments.forEach((payment) => {
        if (payment.invoice_id) {
          let invoices = this.state.invoices;
          let receipts = this.state.receipts;
          this.iexpress.getInvoiceData(payment.invoice_id).then((data) => {
            invoices.push(data);
            this.setState({ invoices: invoices });
          });
          this.getReversalReceipt(payment).then((data) => {
            if (data) {
              receipts.push({
                easypay_payment_id: payment.ep_key,
                invoice: data.invoice,
              });
              this.setState({ receipts: receipts });
            }
          });
        }
      });
    }

    getReversalReceipt(payment) {
      return this.api
        .get("easypay_payment_invoices", {
          easypay_payment_id: payment.ep_key,
          reversal: true,
        })
        .then(({ data = null }) => {
          if (data.count > 0) {
            let invoice_id =
              data.easypay_payment_invoices[0].invoicexpress_invoice_id;
            let invoice_type =
              data.easypay_payment_invoices[0].invoice_type ===
              "reversal-invoice"
                ? "invoice"
                : "receipt";
            return this.iexpress.getInvoiceData(invoice_id, invoice_type);
          }
        });
    }

    /**
     *
     */

    render() {
      return this.state.easypay_payments_history ? (
        this.renderList()
      ) : (
        <div>
          <CircularProgress color="primary" />
        </div>
      );
    }

    renderList() {
      const { easypay_payments_history } = this.state;

      return (
        <>
          {!this.props.entity_id && (
            <Row className="align-mid">
              <Col md={8}>
                <Form style={{ width: "100%" }}>
                  <Form.Control
                    type="text"
                    placeholder="Pesquisar por entidade, nº fatura, equipamento, emissor, utente, consultor.."
                    onChange={this.onChange}
                  />
                </Form>
              </Col>
              <Col md={2}>
                <Typography variant="body2">
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.toggleAdvancedFilter.bind(this)}
                  >
                    <FontAwesomeIcon icon="filter" className="filter" />
                    Filtro Avançado
                  </Button>
                </Typography>
              </Col>
            </Row>
          )}
          {!this.props.entity_id && this.props.store.advancedFilter && (
            <Col md={8}>
              <RequestsHistoryFilterForm
                searchValues={this.props.store.searchValues}
                onChange={this.advancedChange}
              ></RequestsHistoryFilterForm>
            </Col>
          )}
          <RequestsHistoryTable
            payments={easypay_payments_history}
            invoices={this.state.invoices}
            receipts={this.state.receipts}
            showAllColumns={this.props.entity === undefined}
          />

          <Grid container>
            <Grid item md={12}>
              <TablePagination
                className="pagination"
                rowsPerPageOptions={[]}
                count={this.props.store.count}
                rowsPerPage={this.rowsPerPage}
                page={this.props.store.page}
                onChangePage={this.handleChangePage}
              />
            </Grid>
          </Grid>
        </>
      );
    }
  }
);

export default RequestsHistoryListing;
